package link.erpango.quip.platform.services

class NotificationService {
    // Stub implementation for JS
}
